// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GWUS","select":"styles_select__2Wk87"};